import { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const CreateVillage = (props) => {
  const httpClient = useHttpClient(true);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [Open, setOpen] = useState(false);
  const [CreateModal, setCreateModal] = useState(false);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const [spinner, setSpinner] = useState(false);
  const [commune, setCommune] = useState();
  const [communes, setCommunes] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [selectedDepartement, setSelectedDepartement] = useState<any>();
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const [departements, setDepartements] = useState([]);
  const [villageCodeError, setVillageCodeError] = useState('');

  const onSubmit = async (data) => {
    const villageData = {
      name: data['village_name'],
      commune: JSON.parse(data['commune']),
      code: data['village_code'],
    };
    const villagesList = props.allVillages || [];
    const codeAlreadyUsed = villagesList.some((village) => village.code === villageData.code);
    if (codeAlreadyUsed) {
      setVillageCodeError(props.t('village_code_already_used'));
      return;
    } else {
      setVillageCodeError('');
    }

    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/village`, villageData);
      if (response && (await response).status === 200) {
        setSpinner(false);
        props.villages();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    resetField('village_name');
    resetField('commune');
    resetField('village_code');
    setCreateModal(!CreateModal);
    setSelectedCountry('');
    setSelectedRegion('');
    setSelectedDepartement('');
    setVillageCodeError('');
  };

  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient, selectedCountry]);

  useEffect(() => {
    const getRegions = () => {
      if (!selectedCountry) return;
      httpClient.current?.get(`/api/region/all`).then((response) => {
        let regions = response.data;
        console.log(regions);
        regions = regions.filter((region) => region.country.id === JSON.parse(selectedCountry).id);
        console.log(regions);
        console.log(selectedCountry);
        setRegions(regions);
      });
    };
    getRegions();
  }, [selectedCountry]);
  useEffect(() => {
    if (!selectedRegion) return;
    const getDepartements = () => {
      httpClient.current?.get(`/api/departement/all`).then((response) => {
        let departements = response.data;
        departements = departements.filter((departement) => departement.region.id === JSON.parse(selectedRegion).id);
        setDepartements(departements);
      });
    };
    getDepartements();
  }, [httpClient, selectedRegion]);
  useEffect(() => {
    if (!selectedDepartement) return;
    const getCommunes = () => {
      httpClient.current?.get(`/api/commune/all`).then((response) => {
        let communes = response.data;
        communes = communes.filter((commune) => commune.departement.id === JSON.parse(selectedDepartement).id);
        setCommunes(communes);
      });
    };
    getCommunes();
  }, [httpClient, selectedDepartement]);

  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_village')}
      </Button>
      <Modal isOpen={CreateModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_village')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <label htmlFor={'village_name'}>{props.t('village_name')}</label>
                  <input
                    name="village_name"
                    id="village_name"
                    className="form-control"
                    {...register('village_name', { required: true })}
                  />
                  <span>{errors.country && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'village_code'}>Code</label>
                  <input
                    name="village_code"
                    id="village_code"
                    className="form-control"
                    minLength={3}
                    maxLength={3}
                    {...register('village_code', { required: true })}
                  />
                  <span>{errors.country && <p>{props.t('errors_champ')}</p>}</span>
                  {villageCodeError && <span>{villageCodeError}</span>}
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'country_name'}>{props.t('country_name')}</label>
                  <select
                    name="country"
                    id="country"
                    className="form-control"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                    placeholder={props.t('select_country_name')}
                  >
                    <option value="">{props.t('select_country_name')}</option>
                    {countries.map((country, index) => (
                      <option id={country.id} key={index} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <FormGroup className={`form-row ${selectedCountry ? 's' : 'd-none'}`}>
                  <label htmlFor={'region_name'}>{props.t('region_name')}</label>
                  <select
                    name="region"
                    id="region"
                    className="form-control"
                    value={selectedRegion}
                    onChange={(e) => setSelectedRegion(e.target.value)}
                  >
                    <option value="">{props.t('select_region_name')}</option>

                    {regions.map((region, index) => (
                      <option id={region.id} key={index} value={JSON.stringify(region)}>
                        {region.name}
                      </option>
                    ))}
                  </select>
                  <span>{errors.region && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className={`form-row ${selectedRegion ? 's' : 'd-none'}`}>
                  <label htmlFor={'departement_name'}>{props.t('departement_name')}</label>
                  <select
                    name="departement"
                    id="departement"
                    className="form-control"
                    value={selectedDepartement}
                    onChange={(e) => setSelectedDepartement(e.target.value)}
                  >
                    <option value="">{props.t('select_departement_name')}</option>

                    {departements.map((dep, index) => (
                      <option id={dep.id} key={index} value={JSON.stringify(dep)}>
                        {dep.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <FormGroup className={`form-row ${selectedDepartement ? 's' : 'd-none'}`}>
                  <label htmlFor={'commune_name'}>{props.t('commune_name')}</label>
                  <select
                    name="commune"
                    id="commune"
                    className="form-control"
                    {...register('commune', { required: true })}
                  >
                    <option value="">{props.t('select_commune_name')}</option>
                    {communes.map((com, index) => (
                      <option id={com.id} key={index} value={JSON.stringify(com)}>
                        {com.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateVillage);
